export default "__VITE_ASSET__DKp05ZlF__"